export class tConsultCertModel {

    shopID: string;

    consultNumber: string;
    patientID: string;
    isViewHKID: string;
    therapistID: string;
    startDate: Date;
    endDate: Date;
    apm: string;
    totalDays: number;
    printDiagonsis: string;
    printDiagonsisEng: string;
    printRemark: string;
    printRemarkEng: string;
    printConsultRemark: string;
    printConsultRemarkEng: string;


    inActive: string;
    lastModifyDatetime: Date;
    lastModifyUserID: string;
    prescriptionPrintDate:Date;
    printPrescription:string;
    printPrescriptionEng:string;
    isPrintedPrescriptionCert:string;
    firstPrintingPrescriptionUser:string;
    firstPrintingPrescriptionUserDateTime:Date;
    printMedicalReport:string;
    isPrintMedicalReport:string;
}


export class tConsultCertModelPrint extends tConsultCertModel {
    startDatePrint: string;
    endDatePrint: string;

    ArrivalDatePrint: string;
    printDate:string;
    therapistName: string;
    employee_Chinese_name: string;
    employee_ENG_name:string;

    regNo1: string;
    regNo2: string;
    doctorRemark:string;

}

export class tProcedureFeeModel {
    DoctorFee:number;
    oRoom: number;
    LaboratorFee: number;
    ConsultationFee:number;
    MedicationFee:number;
    nonRefundable:number;
    Total:number;
    paidDeposit:number;
    balance:number;
    Remark:string;


}